import { OptionTuple } from '~/components/Input/Select/Select';
import { ForwardedRef, forwardRef, useMemo } from 'react';
import { Input, SelectProps } from '~/components/Input';
import { useWeightClassesListQuery } from '../queries';
import { BaseFormState } from '~/types/BaseFormState';
import { formatWeightClass } from '~/utils/weight';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & {
  query?: Parameters<typeof useWeightClassesListQuery>[0];
};

function WeightClassSelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useWeightClassesListQuery(props.query);

  const options = useMemo<OptionTuple[]>(() => {
    return data.filter(wc => wc.active).map(wc => [formatWeightClass(wc), wc.id]);
  }, [data]);

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Alla viktklasser'}
      aria-label={props['aria-label'] ?? 'Viktklass'}
      disabled={isLoading || props.disabled}
      options={options}
      ref={ref}
      {...props}
    />
  );
}

export const WeightClassSelect = forwardRef(WeightClassSelectElement) as <TFormState extends BaseFormState>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof WeightClassSelectElement>;
